import { Textarea } from '@components/core-ui/form-elements/Textarea';
import { TProps } from '@pages/ContactSales/types/TProps';
import ASImage from './images/as.svg';
import OneImage from './images/one.svg';
import image from './images/top.png';
import ViewImage from './images/view.svg';
import { Wrapper } from './styles/Wrapper';

export const ContactSalesLeftSection = ({ formState, setFormState }: TProps) => {
  return (
    <Wrapper>
      <img src={image} alt="" />
      <h1>Contact The AutoScript Team</h1>
      <h2>Our Product Specialists Are Ready to Help</h2>
      <p>
        No matter your role – agency owner, court reporter, transcriber/editor, production manager, or legal
        professional – the AutoScript product suite delivers a unified, modern court reporting and deposition workflow
        from capture to certified transcript delivery.
      </p>

      <div className="form-section">
        <div>
          <h4 className="mb-[5px]">Which product are you interested in? *</h4>
          <h5>Select all that apply so we can route your request to the right team</h5>
        </div>

        <div className="products">
          <div
            className={`check-product-button ${formState.interested.asone ? ' active' : ''}`}
            onClick={() => {
              setFormState({
                ...formState,
                interested: {
                  ...formState.interested,
                  asone: !formState.interested.asone,
                },
              });
            }}
          >
            <OneImage />
            Reporter Capture and Live Editing Tool
            <p className="text-sm">
              AutoScriptOne delivers reliable multi-channel recording, live transcript streaming, and in-session editing
              – empowering reporters to produce accurate, real-time, rough and certified transcripts more efficiently.
            </p>
          </div>

          <div
            className={`check-product-button ${formState.interested.attorney ? ' active' : ''}`}
            onClick={() => {
              setFormState({
                ...formState,
                interested: {
                  ...formState.interested,
                  attorney: !formState.interested.attorney,
                },
              });
            }}
          >
            <ViewImage />
            Realtime Transcripts and Productivity Tools for Attorneys
            <p className="text-sm">
              Elevate your services - AttorneyView securely streams transcripts in real-time, enabling attorneys and
              other participants to take notes and review transcripts during and after proceedings.
            </p>
          </div>

          <div
            className={`check-product-button ${formState.interested.asWeb ? ' active' : ''}`}
            onClick={() => {
              setFormState({
                ...formState,
                interested: {
                  ...formState.interested,
                  asWeb: !formState.interested.asWeb,
                },
              });
            }}
          >
            <ASImage />
            AutoScript Hub – AI-Powered Transcript Automation
            <p className="text-sm">
              Transform recorded audio/video into a highly accurate, ready-to-edit AI rough draft within minutes,
              significantly accelerating transcript production while reducing costs.
            </p>
          </div>

          <div
            className={`check-product-button ${formState.interested.notSure ? ' active' : ''}`}
            onClick={() => {
              setFormState({
                ...formState,
                interested: {
                  ...formState.interested,
                  notSure: !formState.interested.notSure,
                },
              });
            }}
          >
            Not sure - Help me choose
            <p className="text-sm">Tell us a bit about your use case and we’ll recommend a setup.</p>
          </div>
        </div>

        {formState.interested.notSure ? (
          <div className="line">
            <Textarea
              value={formState.notSureNotes}
              label="Briefly describe how you currently handle transcripts or recordings, and what you’d like to improve. (optional)"
              onChange={(event) => {
                setFormState({
                  ...formState,
                  notSureNotes: event.target.value,
                });
              }}
            />
          </div>
        ) : null}
      </div>
    </Wrapper>
  );
};
